export default __webpack_public_path__ + "static/media/Martin-bis.c3c05185.png";